import { EMPLOYMENT_TYPE, type EmploymentType } from '@/common/api/types/capacity/resources';
import type { ResourceFilterKey } from '@/common/api/types/itemFilters';

// Index positions are encoded into saved/shared filter URLs (see employmentTypeFilter.ts) -
// append new types at the end and never reorder or remove one, or existing links decode to
// the wrong type. AI_AGENT stays here unconditionally so decoding is flag-independent; the
// flag instead gates which options useGetFilterOptions renders for selection.
export const EMPLOYMENT_TYPE_FILTER_VALUES = [
  EMPLOYMENT_TYPE.EMPLOYEE,
  EMPLOYMENT_TYPE.CONTRACTOR,
  EMPLOYMENT_TYPE.PARTNER,
  EMPLOYMENT_TYPE.ON_DEMAND,
  EMPLOYMENT_TYPE.AI_AGENT,
] as const satisfies readonly EmploymentType[];

export const RESOURCE_PICKLIST_FILTERS = [
  'locationId',
  'roleId',
  'skillId',
  'holidaySchemeId',
  'workloadSchemeId',
  'loopId',
  'employmentType',
] as const satisfies readonly ResourceFilterKey[];

export const RESOURCE_BOOLEAN_FILTERS = [
  'showDeactivatedMembers',
] as const satisfies readonly ResourceFilterKey[];

export const RESOURCE_FILTER_KEYS = [
  ...RESOURCE_PICKLIST_FILTERS,
  ...RESOURCE_BOOLEAN_FILTERS,
] as const satisfies readonly ResourceFilterKey[];

export const getResourceTableFilters = () => [...RESOURCE_FILTER_KEYS] as const;
